import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'katex/dist/katex.min.css';
import './utils/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Polyfill global for Quill and other libraries
(window as any).global = window;

// Fix for React DOM crash when Google Translate / browser auto-translate wraps or mutates DOM nodes:
// Prevents "NotFoundError: Failed to execute 'insertBefore' on 'Node'"
// and "NotFoundError: Failed to execute 'removeChild' on 'Node'"
if (typeof Node === 'function' && Node.prototype) {
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('DOM insertBefore fallback: referenceNode parent is not current node.', this, referenceNode);
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('DOM removeChild fallback: child parent is not current node.', this, child);
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // Note: React.StrictMode removed because it conflicts with Quill.js (rich text editor).
  // StrictMode double-renders components in dev mode, but Quill manipulates the DOM directly,
  // causing "concurrent rendering" crashes when pasting complex content (e.g. tables from Word).
  // This has ZERO effect on production builds - StrictMode is dev-only.
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
